import "./css/style.scss";
import Reveal from "./Components/Reveal.jsx";
import { content } from "./content.js";

export default function Team({ content }) {
  return (
    <section id="team">
      <Reveal delay={0.2}>
        <div className="section-title">Team</div>
      </Reveal>
      <div className="team">
        <div className="container">
          <Reveal delay={0.4}>
            <div className="item-img">
              <img src={content[0].imgSrc} />
            </div>
          </Reveal>
          <Reveal delay={0.5}>
            <div className="item-info">
              <div className="name">{content[0].name}</div>
              <div className="description">{content[0].description}</div>
            </div>
          </Reveal>
          <Reveal delay={0.6}>
            <div className="item-img">
              <img src={content[1].imgSrc} />
            </div>
          </Reveal>
          <Reveal delay={0.7}>
            <div className="item-info">
              <div className="name">{content[1].name}</div>
              <div className="description">{content[1].description}</div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
